var TRACKINGDATA = {
  modalLocationAllow: {
    'Event Metadata': {
      action_category: 'user location access modal',
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:location access:[click text]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
  },
  modalLocationZipSubmit: {
    'Event Metadata': {
      action_category: 'user location access modal',
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:location access:zip submit',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
    Dealer: {
      dealer_locator_search_type: 'Zipcode',
      dealer_locator_search_term: '',
    },
  },
  locateBodyShop: {
    'Event Metadata': {
      action_type: 'link',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        type: 'dynamicName',
        search: '[page_name]:selector:[click text]',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
  filteringModel: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:toggle filter',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
  filteringByAwardAndService: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:[click text]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
  filteringByAwardAndServiceInfo: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
  preferredDealer: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] ',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
    },
  },
  dealerDirections: {
    'Event Metadata': {
      action_type: 'link',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] ',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
    },
  },
  dealerTelephone: {
    'Event Metadata': {
      action_type: 'link',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] ',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
      selected_dealer_phone_number: '',
    },
  },
  dealerCTA: {
    'Event Metadata': {
      action_type: 'link',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] ',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
      // selected_dealer_link: '' Optional
    },
  },
  selectDealer: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:reposition map: [selected_dealer_name]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
    },
  },
  viewDealerDetails: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:results:[selected_dealer_name]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] results',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
    },
  },
  moreDealers: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:[click text]',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
  searchSelectedArea: {
    'Event Metadata': {
      action_type: 'selector',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
  expandDepartments: {
    'Event Metadata': {
      action_type: 'selector',
      action_category: 'locate dealer details',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:dealer details:',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
    },
  },
  searchDealerZipcode: {
    'Event Metadata': {
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:search',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      dealer_locator_search_type: 'Zipcode',
      dealer_locator_search_term: '',
    },
  },
  searchDealerState: {
    'Event Metadata': {
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:search',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      dealer_locator_search_type: 'City, State',
      dealer_locator_search_term: '',
    },
  },
  searchDealerName: {
    'Event Metadata': {
      action_type: 'cta',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:search',
        type: 'dynamicName',
      },
      {
        key_name: 'body_style',
        parent: 'Model',
        type: 'bodyStyle',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      dealer_locator_search_type: 'Name',
      dealer_locator_search_term: '',
    },
  },
  departmentPhone: {
    'Event Metadata': {
      action_type: 'link',
      action_category: 'locate dealer details',
    },
    Model: {
      model_name: 'no model',
      model_year: 'no model',
      body_style: 'no model',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:dealer details:call [selected_dealer_name]: ',
        type: 'dynamicName',
      },
    ],
    Dealer: {
      selected_dealer_id: '',
      selected_dealer_zipcode: '',
      selected_dealer_name: '',
      selected_dealer_address: '',
      selected_dealer_phone_number: '',
    },
  },
  tabsSelector: {
    'Event Metadata': {
      action_type: 'selector',
    },
    Model: {
      model_name: 'no model',
      model_year: 'no model',
      body_style: 'no model',
    },
    dynamic_variables: [
      {
        key_name: 'action_label',
        parent: 'Event Metadata',
        search: '[page_name]:selector:[click text]',
        type: 'dynamicName',
      },
      {
        key_name: 'action_category',
        parent: 'Event Metadata',
        search: '[page_name] selector',
        type: 'dynamicName',
      },
    ],
  },
};

module.exports = TRACKINGDATA;
